import { gql } from '@apollo/client';
import { client } from '../../../../graphql/client';

export const START_PICKUP_WORK = gql`
  mutation StartPickupWork($taskId: Long!, $startWorkTime: String) {
    startPickupWork(taskId: $taskId, startWorkTime: $startWorkTime)
  }
`;

export interface StartPickupWorkVariables {
  taskId: string;
  /**
   * 司机点击「开始作业」的时刻（ISO-8601 UTC）。离线补传时**必须**带上，
   * 否则后端会把恢复网络的时刻当成开工时刻。不传则由后端取当前时间。
   */
  startWorkTime?: string;
}

export interface StartPickupWorkResponse {
  startPickupWork: boolean;
}

/**
 * 「开始作业」打点。启动页滑块与只读态横幅两个入口共用本函数——
 * 两处的失败语义必须一致，各写一遍迟早会漂移。
 *
 * **永不抛错**：开始作业时间是打点而非业务前置条件，写失败也要放司机进任务列表，
 * 否则弱网时司机整天开不了工。返回值只用于决定要不要 toast，以及是否需要转入离线补传队列。
 *
 * 需要区分错误类型（如离线重传要靠 networkError 判断该删还是该留）时，直接用会抛错的 [startPickupWork]。
 */
export const startPickupWork = async (taskId: string, startWorkTime?: string): Promise<void> => {
  await client.mutate<StartPickupWorkResponse, StartPickupWorkVariables>({
    mutation: START_PICKUP_WORK,
    variables: { taskId, startWorkTime },
  });
};

export const startPickupWorkNonBlocking = async (taskId: string, startWorkTime?: string): Promise<boolean> => {
  try {
    await startPickupWork(taskId, startWorkTime);
    return true;
  } catch (error) {
    console.error('startPickupWork failed (non-blocking):', error);
    return false;
  }
};
